<template>
  <actions-menu v-model:dialogEdit="editRequestDialog" :ShowDialogConsult="false" dialogConsult="DelivryCompanyDetails"
    v-model:dialogConsult="editRequestDialog" :Id="Id" :dialogConsultUrl="idBrand" v-model:dialogDelete="dialog"
    :ShowDialogEdit="isEditMode" :ShowDialogDelete="false" :ShowDialogStatus="false" />


  <v-dialog v-model="editRequestDialog">
    <v-card elevation="0" width="1100px" class="py-2" style="border-radius: 12px">
      <v-card-title>
        <span class="title">{{
          $t("Delivery.DeliveryPerson.Edit")
        }}</span></v-card-title>

      <div class="row justify-content-start ma-4">
        <div class="col">
          <v-card-title class="text-left"><span>{{
            $t("Delivery.DeliveryPerson.Name")
          }}</span></v-card-title>
          <v-text-field v-model="deliveryPerson.fullName" maxlength="50" :readonly="!isDeliveryResult"
            :class="!isDeliveryResult ? 'readonly-field' : ''"></v-text-field>
        </div>

        <div class="col-6">
          <v-card-title class="text-left"><span>{{
            $t("Delivery.DeliveryPerson.email")
          }}</span></v-card-title>
          <v-text-field v-model="deliveryPerson.emailAddress" maxlength="50" :readonly="!isDeliveryResult"
            :class="!isDeliveryResult ? 'readonly-field' : ''"></v-text-field>
        </div>

        <div class="col-6">
          <v-card-title class="text-left">{{
            $t("Delivery.DeliveryPerson.Phone")
          }}</v-card-title>
          <v-text-field v-model="deliveryPerson.phone" maxlength="15" :readonly="!isDeliveryResult"
            :class="!isDeliveryResult ? 'readonly-field' : ''"></v-text-field>
        </div>



        <div class="col-6">
          <v-card-title class="text-left">{{
            $t("Delivery.DeliveryPerson.cin")
          }}</v-card-title>
          <v-text-field v-model="deliveryPerson.cin" maxlength="20" :readonly="!isDeliveryResult"
            :class="!isDeliveryResult ? 'readonly-field' : ''"></v-text-field>
        </div>
        <div class="col-6">
          <v-card-title class="text-left">{{
            $t("Delivery.DeliveryPerson.Vehicle")
          }}</v-card-title>
          <v-autocomplete v-model="deliveryPerson.selectedAutomobile" :items="AutoMobilesAvailable" item-title="name"
            item-value="id" hide-details :readonly="!isDeliveryResult"
            :class="!isDeliveryResult ? 'readonly-field' : ''"></v-autocomplete>

        </div>
        <div class="col-6">
          <uploadLogo :API="2" :logoUrl="initLogo" @addLogo="setLogo" :namelogo="logoImage ?? initLogo"
            :readonly="!isDeliveryResult" :class="!isDeliveryResult ? 'readonly-field' : ''" />
        </div>
      </div>
      <card-actions :yes="updateDeliveryPersonInfo" v-model:no="editRequestDialog" :loader="loader"
        :yesDisable="!isDeliveryResult || loader" width="300px" :yesTitle="$t('actions.save')" />
    </v-card>
  </v-dialog>
</template>

<script>
import actionsMenu from "@/genericComponent/actionsMenu.vue";
import uploadLogo from '@/genericComponent/uploadLogo.vue'
import cardActions from "@/genericComponent/cardActions.vue";
import { getDeliveryPersonInfoById, updateDeliveryPersonInfo, getAllAutoMobiles } from "@/api/index";
export default {
  components: { actionsMenu, cardActions, uploadLogo },
  props: ["idBrand", "Id", "getBrand", "getBrandListAfterDelete", "companyId", "isDeliveryResult"],

  created() {
    this.fetchDeliveryPersonInfo();
  },
  data() {
    return {
      editRequestDialog: false,
      AutoMobilesAvailable: [],
      initLogo: null,
      loader: false,
      deliveryPerson: {
        fullName: "",
        emailAddress: "",
        phone: "",
        cin: "",
        selectedAutomobile: null,
        logoImage: null,
      },
    };
  },
  watch: {
    editRequestDialog(newValue) {
      if (newValue) {
        getAllAutoMobiles(this.companyId).then((response) => {
          this.AutoMobilesAvailable = response.data
        })
      }
    }
  },
  methods: {
    setLogo(value) {
      this.logoImage = value
      //this.$emit('setLogo', value)
    },
    fetchDeliveryPersonInfo() {
      getDeliveryPersonInfoById(this.idBrand)
        .then((response) => {
          const data = response.data.getDeliveryPersonsByCompanyIdResponse;
          this.deliveryPerson = {
            fullName: data.fullName,
            emailAddress: data.emailAddress,
            phone: data.phone,
            cin: data.cin,
            selectedAutomobile: data.automobileId || "",
          };
          this.initLogo = data.photoUrl
        })
        .catch((error) => {
          console.error("Failed to fetch delivery person details:", error);
        });
    },
    updateDeliveryPersonInfo() {
      this.loader = true;

      const formData = new FormData();
      formData.append("fullName", this.deliveryPerson.fullName);
      formData.append("emailAddress", this.deliveryPerson.emailAddress);
      formData.append("phone", this.deliveryPerson.phone);
      formData.append("cin", this.deliveryPerson.cin);
      if (this.logoImage) formData.append('Photo', this.logoImage)
      if (this.deliveryPerson.selectedAutomobile) formData.append("AutomobileId", this.deliveryPerson.selectedAutomobile)

      updateDeliveryPersonInfo(this.idBrand, formData)
        .then(() => {
          this.loader = false;
          this.editRequestDialog = false;
          this.$emit("updateSuccess");
        })
        .catch((error) => {
          this.loader = false;
          console.error("Failed to update delivery person details:", error);
        });
    },
  },
};
</script>
<style scoped>
h1 {
  font-family: inter;
  font-size: 18px;
  line-height: 29px;
  font-weight: 600;
  color: #0d0849;
  text-align: center;
}

.v-card-text {
  font-family: inter;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: #768da9;
}

.rounded-table {
  border-radius: 10px;
}

.custom-divider {
  border-top: 1px solid;
  border-color: currentColor;
}

.border-right {
  border: 1px solid #ddd;
  text-align: center;
  border-style: dotted;
  padding: 2px 4px;
}

.totals {
  margin-top: 20px;
  /* font-weight: bold; */
}

.align-right {
  padding-right: 85px;
  text-align: right;
  position: relative;
}

.totals p {
  margin: 5px 0;
}

.align-devise {
  float: right;
  margin-left: -16px;
}

.v-card-title {
  font-family: inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #5b6d8e;
}

.textConsumptionThreshold {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 29px;
  display: flex;
  align-items: center;
  color: #080c3e;
}

.customWarningHint {
  color: #f25c5c;
  padding: 12px 0px 12px 12px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 0px;
  display: block;
  text-align: left;
  text-wrap: nowrap;
}
</style>
